module.exports = __webpack_public_path__ + "static/media/view6.74a8465f.jpg";